import * as PIXI from 'pixi.js'

const PARTICLE_LIFETIME = 30
const FADE_START = 20
const MOBILE_BREAKPOINT = 640
const graphicsPool = []
const textPool = []

const removeFromParent = (displayObject) => {
  if (displayObject?.parent) {
    displayObject.parent.removeChild(displayObject)
  }
}

const acquireGraphics = (color) => {
  const graphics = graphicsPool.pop() || new PIXI.Graphics()
  graphics.clear()
  graphics.alpha = 1
  graphics.rotation = 0

  graphics.beginFill(color)
  graphics.moveTo(0, -8)
  graphics.lineTo(-4, -12)
  graphics.lineTo(4, -12)
  graphics.lineTo(0, -8)
  graphics.endFill()

  graphics.beginFill(0xffffff, 0.5)
  graphics.drawCircle(-2, -2, 3)
  graphics.endFill()
  return graphics
}

const recycleGraphics = (graphics) => {
  if (!graphics) return
  removeFromParent(graphics)
  graphics.clear()
  if (!graphicsPool.includes(graphics)) {
    graphicsPool.push(graphics)
  }
}

const acquireText = (textValue, color, fontSize) => {
  const text = textPool.pop() || new PIXI.Text('', {
    fontFamily: 'Arial',
    fontSize,
    fill: color,
    fontWeight: 'bold',
    stroke: 0xffffff,
    strokeThickness: 3,
  })
  const style = text.style
  style.fontSize = fontSize
  style.fill = color
  text.text = textValue
  text.anchor.set(0.5)
  text.alpha = 1
  return text
}

const recycleText = (text) => {
  if (!text) return
  removeFromParent(text)
  text.alpha = 1
  if (!textPool.includes(text)) {
    textPool.push(text)
  }
}

function createFloatingParticle(container, x, y, color, textValue, particlesArray) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT
  const fontSize = isMobile ? 24 : 16

  const particleGraphic = acquireGraphics(color)
  particleGraphic.position.set(x, y)
  container.addChild(particleGraphic)

  const text = acquireText(textValue, color, fontSize)
  text.position.set(x + 20, y)
  container.addChild(text)

  const particleObj = {
    graphics: particleGraphic,
    text,
    life: 0,
    velocity: 0,
    update() {
      this.life += 1
      // Mouvement vers le haut (valeurs Y décroissantes)
      this.velocity -= 0.2
      this.graphics.y += this.velocity
      this.graphics.rotation += 0.05

      if (this.life > FADE_START) {
        const fadeProgress = (this.life - FADE_START) / (PARTICLE_LIFETIME - FADE_START)
        const alpha = fadeProgress >= 1 ? 0 : 1 - fadeProgress
        this.graphics.alpha = alpha
        this.text.alpha = alpha
      }

      this.text.y += this.velocity
    },
    isDead() {
      return this.life > PARTICLE_LIFETIME
    },
    destroy() {
      recycleGraphics(this.graphics)
      recycleText(this.text)
      this.life = 0
      this.velocity = 0
    },
  }

  if (particlesArray) {
    particlesArray.push(particleObj)
  }
}

export function createSunParticle(container, x, y, particlesArray) {
  createFloatingParticle(container, x, y, 0xFACC15, '☀️ +1', particlesArray)
}

export function createWaterParticle(container, x, y, particlesArray) {
  createFloatingParticle(container, x, y, 0x3B82F6, '+2', particlesArray)
}
